import { Link } from "react-router-dom";
import FaqAccordion from "@/components/base/FaqAccordion";
import SectionTag from "@/components/base/SectionTag";
import { faqList } from "@/mocks/faq";

export default function FaqPreviewSection() {
  const preview = faqList.slice(0, 5);

  return (
    <section className="w-full bg-background-50 py-20 md:py-28" id="faq-preview">
      <div className="mx-auto w-full max-w-[1320px] px-5 md:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:gap-16">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionTag tone="primary">常见疑问</SectionTag>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              投稿的人最常问的几件事
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-[15px]">
              关于匿名、安全、材料要求与后续跟进，我们把高频疑问整理成了完整问答，方便你在提交前先确认。
            </p>
            <Link
              to="/faq"
              className="mt-8 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-50"
            >
              查看全部问答
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <FaqAccordion items={preview} />
        </div>
      </div>
    </section>
  );
}